angular.module('components.userReport', [])
    .constant("Constants", {
        ReportGroupName: {
            sales: 'FÖRSÄLJNING'
        }, ReportName: {
            salesWhen: 'Fsg (När)',
            salesWhenAndCustOrd: 'Fsg (När) + KundOrd Plock'
        }
    })
    .component('userReport', {
        templateUrl: 'main/analysis/userReports/userReport.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            selectedReport: '<'
        },
        controller: controller
    });

// @ngInject
function controller($state, AnalysisApiService, ToasterService, DS, $cookies, $anchorScroll, $location, $translate, confirmationDialogService, AuthService, Constants, ENV) {
    var vm = this;

    // properties
    vm.reportGroups = [];
    vm.selectedReport = undefined;
    vm.selectedGroup = {};
    vm.loadedReportPath = [];
    vm.pivot = {};
    vm.localization = {};
    vm.showNavigation = false;
    vm.selectedTab = {};
    vm.activeTabIndex = -1;
    vm.loadedReport = {};
    vm.isLoading = false;
    vm.token = "";
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.navigate = navigate;
    vm.loadReport = loadReport;
    vm.moveUp = moveUp;
    vm.moveDown = moveDown;
    vm.selectTab = selectTab;
    vm.copySelectedReport = copySelectedReport;
    vm.formatDate = formatDate;
    vm.saveReport = saveReport;
    vm.deleteReport = deleteReport;
    vm.isValidDate = isValidDate;
    vm.canPublishReport = canPublishReport;
    vm.sortDescending = sortDescending;
    vm.sortAscending = sortAscending;
    vm.generate = generate;
    vm.startDate = new Date();
    activate();
    vm.useFiltering = false;
    vm.Constants = Constants;
    vm.cancel = function () {
        vm.isLoading = false;
        vm.pivot.clear();
        vm.pivot.dispose();
        vm.pivot = createPivot();
        var empty = {
            toolbar: true,
            report: {
                dataSource: {
                    data: [{ "test": "0" }]
                }
            }
        };
        vm.pivot.clear();
        vm.pivot.setReport(empty);
        vm.pivot.refresh();
    };

    function activate() {
        vm.startDate.setDate(vm.startDate.getDate() - 60);
    }

    function generate() {
        var startDate = null;
        if (vm.startDate !== null || vm.startDate !== "") {
            startDate = moment(vm.startDate).format('YYYY-MM-DD');
        }
        loadReport(startDate);
    }

    function onInit() {
        AuthService.getAuth0Token().then(function (response) {
            vm.token = response.data.accessToken;
        });
        loadReportGroups();
        AnalysisApiService.getLocalization().then(function (data) {
            vm.localization = data;
            vm.pivot = createPivot();
        });
    }

    function onChanges(changes) {
    }

    function onDestroy() {

    }

    function createPivot() {
        var fm = $("#pivotContainer").flexmonster({
            licenseKey: ENV.FLEXMONSTER_KEY,
            width: '100%',
            height: 700,
            toolbar: true,
            global: {
                localization: vm.localization
            }
        });
        fm.on('dataloaded', function () {
            vm.isLoading = false;
        });
        fm.on('olapstructureerror', function () {
            AuthService.getAuth0Token().then(function (response) {
                vm.token = response.data.accessToken;
            });
        });
        return fm;
    }

    function navigate(report, load) {

        var group = _.find(vm.reportGroups, function (group) {
            return _.some(group.reports, report);
        });
        if (group === undefined) {
            group = _.first(vm.reportGroups);
            report = undefined;
        }
        vm.selectedGroup = group;
        vm.selectedReport = report;

        if (load) {
            loadReport(null);
        }
    }

    function loadReportGroups() {
        try {
            AnalysisApiService.getReportGroups().then(function (response) {
                vm.reportGroups = response;
            });
        }
        catch (exception) {
            ToasterService.showError(exception.message, 'error', "Rapporter");
        }
    }

    function loadReport(startDate) {

        try {
            vm.isLoading = true;

            var reportText = vm.selectedReport.reportObject;
            if (_.startsWith(vm.selectedReport.reportObject, "<")) {
                /* jshint -W117 */
                reportText = fmCovertXmlReport(vm.selectedReport.reportObject);
                /* jshint +W117 */
            }
            var jsonReport = JSON.parse(reportText);

            if (jsonReport.dataSource.dataSourceType === "ocsv" ||
                jsonReport.dataSource.dataSourceType === "csv" ||
                jsonReport.dataSource.type === "ocsv" ||
                jsonReport.dataSource.type === "csv") {

                var dataUrl = DS.defaults.basePath + 'analysis/getCompressedCsvReportData/' + vm.selectedReport.dataSourceId +
                '?startDate=' + startDate + '&token=' + $cookies.getObject('X-JetsoftToken');

                jsonReport.dataSource.filename = dataUrl;
                jsonReport.dataSource = assureDataSourceType(jsonReport.dataSource);
                jsonReport.localization = '';
            }

            if (jsonReport.dataSource.dataSourceType === "api" || jsonReport.dataSource.type === "api") {
                jsonReport.dataSource.requestHeaders = {Authorization: "Bearer " + vm.token};
            }

            jsonReport.dataSource = assureDataSourceType(jsonReport.dataSource);

            vm.pivot.setReport(jsonReport);
            vm.pivot.setOptions({
                grid: {
                    title: vm.loadedReportPath
                }
            });

            vm.pivot.closeFieldsList();
            vm.pivot.refresh();
            vm.loadedReport = vm.selectedReport;
        }
        catch (error) {
            vm.isLoading = false;
            vm.pivot.clear();
            vm.pivot.refresh();
            ToasterService.showError('"' + vm.selectedReport.name + '": ' + error.message, 'error', "Rapporter");
        }
    }

    function moveUp(report) {
        var position = _.indexOf(vm.selectedGroup.reports, report);
        if (position > 0) {
            arrayMove(vm.selectedGroup.reports, position, position - 1);
            var id = "report_" + report.id;
            scrollTo("report_list", id, true);
        }
    }
    function moveDown(report) {
        var position = _.indexOf(vm.selectedGroup.reports, report);
        if (position < vm.selectedGroup.reports.length - 1) {
            arrayMove(vm.selectedGroup.reports, position, position + 1);
            var id = "report_" + report.id;
            scrollTo("report_list", id, false);
        }
    }

    function sortAscending(e) {
        e.preventDefault();
        if (vm.selectedGroup !== undefined && vm.selectedGroup.reports.length > 0) {
            var newSorting = _.orderBy(vm.selectedGroup.reports, 'name', 'asc');
            vm.selectedGroup.reports = newSorting;
            saveSortOrder();
        }
    }

    function sortDescending(e) {
        e.preventDefault();
        if (vm.selectedGroup !== undefined && vm.selectedGroup.reports.length > 0) {
            var newSorting = _.orderBy(vm.selectedGroup.reports, 'name', 'desc');
            vm.selectedGroup.reports = newSorting;
            saveSortOrder();
        }
    }

    function arrayMove(array, from, to) {
        array.splice(to, 0, array.splice(from, 1)[0]);
    }


    function scrollTo(containerId, elementId, up) {
        var element = document.getElementById(elementId);
        if (element !== undefined) {
            var y = up ? element.offsetTop - element.offsetHeight : element.offsetTop + element.offsetHeight;
            $(document.getElementById(containerId)).animate({ scrollTop: y }, 0);
        }
    }

    function selectTab(tabName) {
        if (tabName === vm.selectedTab) {
            vm.showNavigation = !vm.showNavigation;
        } else {
            vm.showNavigation = true;
        }
        vm.selectedTab = tabName;
        var index = _.findIndex(vm.reportGroups, { name: tabName });
        if (index !== vm.activeTabIndex) {
            vm.selectedReport = undefined;
        }
        vm.activeTabIndex = index;
        vm.selectedGroup = vm.reportGroups[index];
        //console.log(angular.toJson(vm.selectedGroup));
    }

    function formatDate(date, formatStr) {
        if (date === undefined) {
            return '';
        }
        return moment(date).format(formatStr);
    }

    function copySelectedReport() {
        if (vm.selectedReport !== undefined) {

            var report = angular.copy(vm.selectedReport);

            report.id = -1;
            report.isShared = false;
            // copy report object changes if loaded report
            if (vm.loadedReport === vm.selectedReport) {
                var reportObj = vm.pivot.getReport();
                reportObj.dataSource.filename = "";
                reportObj.dataSource = assureDataSourceType(reportObj.dataSource);
                report.reportObject = JSON.stringify(reportObj);
            }

            AnalysisApiService.saveUserReport(report).then(function (response) {
                vm.selectedReport = response.data;
                var group = _.find(vm.reportGroups, { reportGroupType: 'userReport' });
                vm.selectedReport.changed = undefined;
                group.reports.push(vm.selectedReport);
                saveSortOrder();

                ToasterService.showSuccess('"' + vm.selectedReport.name + '" ' + $translate.instant("analysis.wasSaved"), $translate.instant("analysis.reports"));
            });
        }
    }

    function saveReport() {
        var group = _.find(vm.reportGroups, { reportGroupType: 'userReport' });
        var isLoadedReport = vm.loadedReport === vm.selectedReport;

        var index = _.indexOf(group.reports, vm.selectedReport);
        if (index > -1) {
            if (isLoadedReport) {
                var reportObj = vm.pivot.getReport();
                reportObj.dataSource.filename = "";
                reportObj.dataSource = assureDataSourceType(reportObj.dataSource);
                vm.loadedReport.reportObject = JSON.stringify(reportObj);
            }
            AnalysisApiService.saveUserReport(vm.selectedReport).then(function (response) {
                vm.selectedReport = response.data;
                group.reports[index] = vm.selectedReport;

                if (isLoadedReport) {
                    vm.loadedReport = vm.selectedReport;
                }
                saveSortOrder();

                ToasterService.showSuccess('"' + vm.selectedReport.name + '" ' + $translate.instant("analysis.wasSaved"), $translate.instant("analysis.reports"));
            });
        }
    }

    function assureDataSourceType(dataSource) {
        if (dataSource.type && dataSource.type.length > 0) {
            dataSource.dataSourceType = dataSource.type;
        } else if (dataSource.dataSourceType && dataSource.dataSourceType.length > 0) {
            dataSource.type = dataSource.dataSourceType;
        }

        return dataSource;
    }

    function saveSortOrder() {

        var group = {
            reportGroupType: 'userReport',
            reports: []
        };

        var userReportGroup = _.find(vm.reportGroups, { reportGroupType: 'userReport' });

        _.forEach(userReportGroup.reports, function (report) {
            group.reports.push({ id: report.id });
        });

        AnalysisApiService.saveUserReportSortOrder(group.reports).then(function (response) {
        });

    }

    function deleteReport() {
        var group = _.find(vm.reportGroups, { reportGroupType: 'userReport' });

        if (_.indexOf(group.reports, vm.selectedReport) > -1) {
            confirmationDialogService.showDialog($translate.instant("analysis.confirmDeleteReport")).then(function (result) {
                if (result === true) {

                    AnalysisApiService.deleteUserReport(vm.selectedReport).then(function (response) {
                        var name = vm.selectedReport.name;
                        _.pull(group.reports, vm.selectedReport);
                        vm.selectedReport = undefined;
                        ToasterService.showSuccess('"' + name + '" ' + $translate.instant("analysis.wasDeleted"), $translate.instant("analysis.reports"));
                    });
                }
            });
        }
    }

    function isValidDate(date) {
        var valid = date !== undefined;
        if (valid) {
            var momentDate = moment(date);
            valid = momentDate.isValid() && moment("1970-01-01").isBefore(momentDate);
        }
        return valid;
    }
    function canPublishReport() {
        return AuthService.canAccess('analysis', 'update');
    }
}
